// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderTotal_container__ruVwr"};